/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  effect,
  EffectRef,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  signal,
  untracked,
  ViewChild,
  computed,
} from '@angular/core';
import { InitialService } from '../../../services/initial.service';
import { isPlatformBrowser } from '@angular/common';
import {
  GoogleMap,
  GoogleMapsModule,
  MapDirectionsService,
} from '@angular/google-maps';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ButtonModule } from 'primeng/button';
import { assets } from '../../../core/constants/assets.const';
import { enquiry, TransportPayment } from '../../../models/enquiries';
import {
  positionTracking,
  joinTrip,
  DriverLoc,
} from '../../../models/socket.model';
import { User } from '../../../models/auth';
import { EncryptionService } from '../../../services/encryption.service';
import { GeoLocationService } from '../../../services/geo-location-service.service';
import { SocketsService } from '../../../services/sockets.service';
import { TripsService } from '../../../services/trips.service';
import { takeUntil } from 'rxjs/operators';
import { trackingMapService } from '../../../services/tackingMap.service';
import { EnquiryService } from '../../../services/enquiries.service';
import { Subject } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { RideCompletedModalComponent } from '../../../modals/ride-completed-modal/ride-completed-modal.component';
import { TrackingSocketService } from '../../../services/tracking-socket.service';
import { RideCompletedComponent } from '../../../modals/ride-completed/ride-completed.component';
import { RouteEtaService } from '../../../services/route-eta.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MapUtils } from '../../../core/helpers/map-utils';
import { I18nService } from '../../../services/i18n.service';

@Component({
  selector: 'logibids-tracking-map',
  imports: [
    ButtonModule,
    RouterModule,
    GoogleMap,
    GoogleMapsModule,
    NgxUiLoaderModule,
  ],
  templateUrl: './tracking-map.component.html',
  styleUrl: './tracking-map.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackingMapComponent implements OnDestroy, AfterViewInit {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly _EnquiryService = inject(EnquiryService);
  private readonly mapDirectionsService = inject(MapDirectionsService);
  private readonly route = inject(ActivatedRoute);
  private readonly translate = inject(I18nService);
  private readonly _encryption = inject(EncryptionService);
  private readonly _TripsService = inject(TripsService);
  private readonly _socket = inject(SocketsService);
  private readonly router = inject(Router);
  public readonly dialogService = inject(DialogService);
  private readonly trackingSocketService = inject(TrackingSocketService);
  private readonly etaService = inject(RouteEtaService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly locationService = inject(GeoLocationService);
  private readonly dataService = inject(trackingMapService);
  private readonly renderer = inject(Renderer2);
  private initialService = inject(InitialService);
  googleMapsReady = this.initialService.googleMapsReady;

  assetsConst = assets;
  isActive = true;
  enquiryId: string;
  protected enquiry = signal<enquiry | null>(null);
  @ViewChild('panel', { static: false }) panel!: ElementRef;

  zoom = signal<number>(13);
  center = signal<google.maps.LatLngLiteral | undefined>(undefined);
  options = signal<google.maps.MapOptions>({
    disableDefaultUI: true,
    zoomControl: false,
    mapTypeControl: false,
    streetViewControl: false,
  });

  markerPosition!: google.maps.LatLngLiteral;
  directionsRendererOptions!: google.maps.DirectionsRendererOptions;
  pickupMarker!: google.maps.LatLngLiteral;
  dropoffMarker!: google.maps.LatLngLiteral;
  driverMarker!: google.maps.LatLngLiteral;
  @ViewChild(GoogleMap) mapRef!: GoogleMap;
  directionsRenderer!: google.maps.DirectionsRenderer;
  markers: { position: google.maps.LatLngLiteral; type: string }[] = [];
  user?: User;
  coords = this.locationService.currentCoords;
  private driverPolyline: google.maps.Polyline | null = null;
  private driverMarkerInstance: google.maps.Marker | null = null;
  infoWindow?: google.maps.InfoWindow;
  // store stop markers keyed by location id
  private stopMarkers: Map<number, google.maps.Marker> = new Map();
  private originalStopsCount: number | null = null;
  private intervalId: any = null;
  private markerAnimationTimeouts: any[] = [];
  statusSocket = signal<string>('');
  private readonly isNearDropoff = signal<boolean>(false);
  private lastDriverLatLng: { lat: number; lng: number } | null = null;
  private coordsEffect!: EffectRef;
  @ViewChild('map', { static: false }) map!: GoogleMap;
  private lastEmitTimestamp = 0;
  data = this.dataService.getId();
  immediateLocationsDirections = signal<
    | {
        id: number;
        data: { lat: number; lng: number };
        address: string;
        index?: number;
      }[]
    | []
  >([]);
  // route throttling / change detection
  buttonProximityMeters = 250;
  private waypointMarkers: Map<any, google.maps.Marker> = new Map<
    any,
    google.maps.Marker
  >();
  // bounds for the currently displayed polyline (used to avoid re-requesting)
  private polylineBounds: google.maps.LatLngBounds | null = null;
  ref?: import('primeng/dynamicdialog').DynamicDialogRef;
  // caches to avoid repeatedly setting the same signal value
  private lastLabel: string | null = null;
  private lastShow: boolean | null = null;
  private lastNextAddr: string | null = null;

  // inside your component class
  private lastAcceptedCoords: { lat: number; lng: number } | null = null;
  private lastAcceptedTs = 0;
  private readonly MIN_INTERVAL_MS = 15000; // 15s
  private readonly MIN_MOVE_METERS = 10; // 10m
  lastCompletedLocationId: number;
  distance = signal<number>(0);
  eta = signal<number>(0);
  transactionEnequiry = signal<TransportPayment | null>(null);
  private pendingMapsTab: Window | null = null;

  // SVG path data for the car icon, used for custom markers.
  private readonly carSvgPaths = `
    <path d="M37.6858 13.3378C37.7625 12.5453 37.8287 10.9523 37.8193 10.1562C37.8096 9.30266 37.6779 7.59941 37.5955 6.74996C37.3165 3.86294 35.2147 1.62144 32.3648 1.66052L33.859 1.38389C36.7812 1.34382 38.8144 3.84239 39.0935 6.72942C39.1752 7.57887 39.3072 9.28212 39.3173 10.1357C39.3263 10.9317 39.2598 12.5248 39.1838 13.3173C38.9146 16.1094 37.0201 18.7639 34.0979 18.804L32.5967 18.5684C35.4465 18.5293 37.4162 16.13 37.6858 13.3378Z" fill="#e50019"/>
    <path d="M1.85792 13.829C1.75992 13.0388 1.64975 11.4482 1.63765 10.6522C1.62399 9.7987 1.70885 8.09248 1.76758 7.24111C1.96695 4.34752 4.00685 2.04923 6.8566 2.01015L5.35539 1.7746C2.43319 1.81467 0.469594 4.36805 0.26946 7.26165C0.211061 8.11302 0.125862 9.81925 0.139097 10.6728C0.151968 11.4688 0.262136 13.0594 0.359797 13.8495C0.705899 16.6332 2.67207 19.2348 5.59426 19.1947L7.08845 18.9181C4.2387 18.957 2.20368 16.6127 1.85792 13.829Z" fill="#e50019"/>
    <path d="M33.5184 18.5555C36.3679 18.5164 38.3387 16.117 38.6075 13.325C38.6843 12.5325 38.7508 10.9394 38.741 10.1434C38.7309 9.28983 38.5993 7.58658 38.5172 6.73713C38.2386 3.8501 36.1361 1.60861 33.2866 1.64769L6.409 2.01625C3.55959 2.05532 1.57855 4.41625 1.31956 7.24721C1.24589 8.06376 1.20283 9.29573 1.21968 10.5248C1.2367 11.766 1.33319 13.0105 1.4099 13.8351C1.68051 16.7323 3.79135 18.9631 6.64085 18.9241L33.5184 18.5555Z" fill="#e50019"/>
    <path d="M17.2612 16.0176C15.7384 12.4789 15.8018 8.67381 17.0248 4.57188C15.1062 4.18829 11.9458 3.01199 10.0792 3.18436C8.18039 7.76268 8.23643 13.1025 10.2344 17.6497C12.1416 17.7485 15.1009 16.4066 17.2612 16.0176Z" fill="white"/>
    <path d="M25.8705 15.8993C27.2961 12.3202 27.1286 8.51829 25.7932 4.45144C27.701 4.01539 29.0533 4.04158 31.1922 4.13368C33.4881 7.87475 33.5678 12.2995 31.4064 16.1196C29.2274 16.2535 28.0409 16.229 25.8705 15.8993Z" fill="white"/>
    <path d="M1.4099 13.8351C1.33319 13.0105 1.2367 11.766 1.21968 10.5248C1.20283 9.29573 1.24589 8.06384 1.31956 7.24721C1.57855 4.41625 3.5595 2.05533 6.409 2.01625L33.2866 1.64769C36.1361 1.60861 38.2386 3.8501 38.5172 6.73713C38.5993 7.58658 38.7309 9.28983 38.741 10.1434C38.7508 10.9317 38.6843 12.5325 38.6075 13.325C38.3387 16.1171 36.3679 18.5164 33.5184 18.5555L6.64085 18.9241C3.79135 18.9631 1.68051 16.7323 1.4099 13.8351ZM32.6567 18.0294C35.326 17.9928 37.1704 15.7462 37.4226 13.1313C37.4941 12.3896 37.5562 10.8974 37.5475 10.152C37.5378 9.35288 37.4147 7.75811 37.338 6.96267C37.0771 4.25917 35.1089 2.16058 32.4396 2.19718L7.27265 2.54229C4.60417 2.57888 2.74881 4.78977 2.50682 7.4403C2.43752 8.20423 2.39722 9.35827 2.41301 10.5092C2.42895 11.6718 2.51968 12.8375 2.59141 13.609C2.84504 16.3224 4.82127 18.4111 7.48975 18.3745L32.6567 18.0294Z" fill="#e50019"/>
    <path opacity="0.68" d="M11.6394 4.85323C9.97345 8.8682 9.81228 13.4683 11.1447 17.6057C10.8225 17.6463 10.5168 17.6641 10.2344 17.6497C8.23648 13.1026 8.18035 7.76277 10.0792 3.18436C11.9458 3.01199 15.1062 4.1883 17.0247 4.57188C16.9046 4.9733 16.7963 5.37303 16.6986 5.76913C14.9689 5.29647 12.973 4.73017 11.6394 4.85323Z" fill="white"/>
    <path d="M14.5471 5.46447C14.54 4.9437 14.519 4.42899 14.4867 3.92216C15.4174 4.17532 16.3073 4.42896 17.0243 4.57253C15.8014 8.67446 15.7379 12.4794 17.2607 16.0182C15.5521 16.3259 13.3435 17.2289 11.551 17.5447C13.4109 15.0694 14.6172 10.5788 14.5471 5.46447Z" fill="white"/>
    <path opacity="0.68" d="M29.277 15.5396C31.7404 12.0992 31.6637 8.12323 29.0725 4.76889C28.375 4.60438 27.6922 4.40318 27.0255 4.22158C28.3562 4.03206 29.5405 4.06208 31.192 4.13375C33.488 7.87481 33.5677 12.2996 31.4062 16.1197C29.8099 16.2175 28.745 16.2297 27.4368 16.1006C28.0137 15.9295 28.618 15.7359 29.277 15.5396Z" fill="white"/>
    <path d="M28.9059 10.3392C28.9343 12.4055 29.1513 14.379 29.5227 16.1954C28.3491 16.2048 27.3323 16.1218 25.8695 15.9002C27.2951 12.321 27.1276 8.51915 25.7923 4.4523C27.1237 4.14789 28.1858 4.06835 29.4328 4.08042C29.065 6.01205 28.8756 8.12611 28.9059 10.3392Z" fill="white"/>
    <path d="M20.7324 2.26167L24.9694 2.20357C24.8147 4.83156 24.4483 8.00684 23.8736 11.4068C23.4631 13.8363 22.9893 16.1265 22.4893 18.1645L17.9464 18.2268C18.138 15.9617 18.464 13.3886 18.9235 10.6718C19.4485 7.56026 20.0781 4.67835 20.7324 2.26167Z" fill="#e50019"/>
    <path d="M30.0497 18.0443L25.8623 16.7186L17.4965 16.8333L10.6894 18.3098L30.0497 18.0443Z" fill="white"/>
    <path d="M29.8325 2.23855L25.683 3.67897L17.3172 3.79369L10.4722 2.50404L29.8325 2.23855Z" fill="white"/>
    <path d="M10.0453 3.26931C9.98742 3.27793 9.92645 3.29042 9.86206 3.30839L5.04089 4.59925C4.25055 4.82379 3.28281 5.53235 2.69538 6.38401C2.72574 6.27185 2.75848 6.16008 2.79431 6.05091C3.39831 5.29759 4.26637 4.69976 5.01012 4.48836L9.83129 3.19792C10.0535 3.13492 10.2476 3.12529 10.4105 3.16778C10.2965 3.16935 10.1859 3.17401 10.0795 3.18363C10.0675 3.2122 10.0573 3.24066 10.0453 3.26931Z" fill="#E2E2E2"/>
    <path d="M10.7619 17.6431C10.5738 17.7508 10.3288 17.7674 10.0303 17.6921L5.17479 16.5336C4.41459 16.3396 3.51505 15.7513 2.88921 14.9992C2.85271 14.8922 2.81925 14.7841 2.78857 14.674C3.39702 15.5224 4.39726 16.2165 5.20234 16.4219L10.0575 17.5796C10.1138 17.5944 10.1669 17.6034 10.2179 17.6109C10.2235 17.6232 10.2284 17.6368 10.2344 17.6495C10.4027 17.6581 10.5791 17.6553 10.7619 17.6431Z" fill="#E2E2E2"/>
    <path d="M2.62982 6.28987C2.89377 6.57394 3.21092 5.82643 3.88241 4.82846C4.53184 3.84125 4.95722 3.40767 4.45652 3.26036C3.99808 3.13041 2.98671 3.35483 2.56496 4.22684C2.11733 5.08431 2.34385 6.0186 2.62982 6.28987Z" fill="white"/>
    <path d="M2.6302 6.28902C2.59668 6.25683 2.56422 6.2156 2.53354 6.1673C2.7809 6.20906 3.09741 5.52619 3.68839 4.64804C4.16271 3.92643 4.51541 3.50158 4.47716 3.26688C4.94257 3.42089 4.52222 3.85525 3.8827 4.82753C3.2113 5.82558 2.89415 6.5731 2.6302 6.28902Z" fill="white"/>
    <path d="M2.72325 4.16478C2.25365 5.06346 2.49089 6.042 2.79065 6.32634C2.79539 6.33138 2.79967 6.33328 2.80407 6.33747C2.74213 6.36051 2.68506 6.34769 2.63018 6.28925C2.34421 6.01799 2.11769 5.08361 2.56532 4.22613C2.76709 3.80837 3.10443 3.54055 3.45193 3.38747C3.16221 3.55574 2.89549 3.8078 2.72325 4.16478Z" fill="white"/>
    <path d="M2.74766 14.9502C3.00371 14.6587 3.34124 15.3968 4.03984 16.376C4.7161 17.345 5.15321 17.7676 4.65674 17.9282C4.20202 18.0702 3.18489 17.8744 2.73939 17.0139C2.26841 16.1687 2.46923 15.2289 2.74766 14.9502Z" fill="white"/>
    <path d="M2.74769 14.9502C2.71505 14.9825 2.68373 15.0243 2.6544 15.0741C2.90052 15.0259 3.23563 15.6991 3.85047 16.5611C4.34439 17.2691 4.70861 17.6841 4.67681 17.92C5.13782 17.753 4.70572 17.3302 4.03978 16.3759C3.34127 15.3968 3.00374 14.6586 2.74769 14.9502Z" fill="white"/>
    <path d="M2.89892 17.0713C2.40486 16.1859 2.61518 15.2012 2.90702 14.9083C2.91163 14.9036 2.91585 14.9015 2.92013 14.8972C2.85759 14.8759 2.80089 14.8899 2.74764 14.9506C2.46921 15.2293 2.26839 16.1691 2.73937 17.0144C2.95252 17.4265 3.29707 17.6849 3.64863 17.828C3.35441 17.6677 3.08088 17.4231 2.89892 17.0713Z" fill="white"/>
    <path d="M37.2023 14.499C37.0547 14.2993 36.5122 15.2216 36.0189 15.924C35.5593 16.5863 35.4407 16.4789 35.7308 16.77C36.0194 17.0104 36.5221 17.364 36.8762 16.5265C37.256 15.6906 37.3927 14.6208 37.2023 14.499Z" fill="white"/>
    <path d="M37.2027 14.499C37.2232 14.5185 37.24 14.5483 37.2538 14.587C37.056 14.6111 36.5801 15.4262 36.1516 16.0549C35.8113 16.5598 35.6754 16.6162 35.7191 16.7588C35.447 16.4807 35.566 16.5771 36.0195 15.9239C36.5127 15.2216 37.0552 14.2993 37.2027 14.499Z" fill="white"/>
    <path d="M36.7693 16.562C37.1483 15.7252 37.2788 14.6303 37.0714 14.5176C37.0686 14.5145 37.0656 14.5146 37.0632 14.5119C37.1233 14.4694 37.1707 14.4601 37.2031 14.4991C37.3936 14.621 37.2569 15.6907 36.8771 16.5266C36.7046 16.9194 36.5033 17.0593 36.3062 17.0534C36.4701 17.0258 36.6297 16.88 36.7693 16.562Z" fill="white"/>
    <path d="M37.081 5.6036C36.939 5.80684 36.3714 4.89976 35.859 4.21116C35.3814 3.56213 35.2658 3.6724 35.5478 3.37344C35.8297 3.12551 36.3225 2.7575 36.6995 3.58581C37.102 4.41045 37.268 5.4756 37.081 5.6036Z" fill="white"/>
    <path d="M37.0812 5.60291C37.1012 5.58316 37.1171 5.55216 37.1298 5.51346C36.9314 5.49365 36.4334 4.69226 35.9878 4.0763C35.6338 3.58095 35.4964 3.52789 35.5361 3.38491C35.2718 3.67001 35.3881 3.57028 35.8593 4.21038C36.3716 4.89899 36.9391 5.80606 37.0812 5.60291Z" fill="white"/>
    <path d="M36.5907 3.55216C36.9925 4.37852 37.153 5.46908 36.9487 5.58788C36.946 5.59106 36.943 5.5911 36.9406 5.59386C37.0019 5.63545 37.0496 5.64339 37.0809 5.60324C37.2679 5.47533 37.102 4.41018 36.6994 3.58537C36.5162 3.19746 36.3112 3.06285 36.1143 3.07371C36.2789 3.09705 36.4424 3.23887 36.5907 3.55216Z" fill="white"/>
    <path d="M31.5943 16.4364L31.6235 16.3893C31.6323 16.3739 32.5586 14.8544 32.9711 13.5983C33.3855 12.336 33.368 11.0793 33.3552 10.2402L33.3541 10.1635C33.3435 9.33178 33.327 8.0769 32.8782 6.82684C32.4314 5.5822 31.4638 4.08932 31.4547 4.07465L31.4241 4.02795L31.4696 3.99578C31.539 3.94652 33.1527 2.81615 34.2899 2.54357C34.3408 2.56507 34.3898 2.58735 34.4396 2.61048C34.4316 2.62343 34.4185 2.63373 34.4022 2.63634C33.387 2.8433 31.8626 3.86589 31.5814 4.05854C31.7497 4.32368 32.58 5.65644 32.9872 6.78801C33.4426 8.05669 33.4583 9.32238 33.4692 10.1717L33.4703 10.2484C33.4833 11.0891 33.5011 12.3536 33.0811 13.6343C32.7051 14.7774 31.9116 16.1317 31.7507 16.4013C32.0126 16.571 33.3337 17.4054 34.3379 17.6832C34.2802 17.707 34.2221 17.7299 34.1629 17.7518C33.0581 17.4037 31.7051 16.5098 31.6406 16.467L31.5943 16.4364Z" fill="#E2E2E2"/>
    <path d="M21.8116 2.34591L21.4667 2.34826L21.3779 3.73614L21.7228 3.73141L21.8116 2.34591Z" fill="#e50019"/>
    <path d="M22.0278 18.1586L21.683 18.1645L21.5562 16.7785L21.901 16.7737L22.0278 18.1586Z" fill="#e50019"/>
    <path d="M8.78706 2.99625C9.04526 3.25821 9.30214 3.05773 9.43329 2.56967C9.56564 2.05668 9.75503 1.56085 9.9993 1.09199C10.2362 0.64883 10.2484 0.380021 9.7446 0.403682C9.24278 0.428082 9.02784 0.394462 8.75708 0.692073C8.52244 0.951772 8.3252 1.61907 8.30515 1.96809C8.29362 2.27422 8.5304 2.73538 8.78706 2.99625Z" fill="#e50019"/>
    <path d="M8.99208 17.9628C9.24301 17.6943 9.50528 17.8873 9.64978 18.372C9.79613 18.8807 9.99905 19.3712 10.2561 19.8328C10.505 20.2696 10.5246 20.538 10.0204 20.5282C9.51805 20.5175 9.30412 20.5575 9.02529 20.267C8.78362 20.0141 8.56815 19.3522 8.53855 19.0038C8.51862 18.6981 8.74267 18.231 8.99208 17.9628Z" fill="#e50019"/>
  `;

  private animationFrameId: number | null = null;
  private isAutoPanning = true;
  private driverHaloMarker: google.maps.Marker | null = null;
  private isRerouting = false;
  private lastRerouteTs = 0;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.user = this._encryption.decryptLocalStorage('profile');
    }

    // react to external data id & shared click (legacy)
    effect(() => {
      const value = this.data();
      if (value !== null && value.length > 0) {
        this.enquiryId = value;
      }
    });

    // react to button clicks emitted by the button component (signal-based)
    let lastClicks = this.dataService.clickCount();
    effect(() => {
      const clicks = this.dataService.clickCount();
      if (clicks !== lastClicks) {
        lastClicks = clicks;
        if (clicks > 0) {
          this.handleDriverButtonClick();
        }
      }
    });

    this.setupCoordsEffect();
    this.setupStatusEffect();
    this.setupMapInitEffect();
  }

  private setupMapInitEffect() {
    if (isPlatformBrowser(this.platformId)) {
      effect(() => {
        if (this.googleMapsReady()) {
          untracked(() => {
            if (!this.enquiry()) {
              this.getEnquiry();
            }
            if (!this.infoWindow) {
              this.infoWindow = new google.maps.InfoWindow();
            }
          });
        }
      });
    }
  }

  private setupStatusEffect() {
    // Immediate emission when status changes (Arrived, Started, etc.)
    effect(() => {
      const status = this.statusSocket();
      if (!status) return;

      untracked(() => {
        // Force an immediate emission check by overriding the 10s throttle for status changes
        // or simply rely on the regular position call if it's frequent enough.
        // But status change should be visible ASAP.
        const enq = this.enquiry();
        const isDriver =
          enq &&
          enq.driver_details?.id &&
          String(enq.driver_details.id) === this.user?.id;

        if (isDriver) {
          // Emit once immediately on status change
          this.position(false, true);
        }
      });
    });
  }

  private setupCoordsEffect() {
    // coords is a signal: this.coords = this.locationService.currentCoords;
    this.coordsEffect = effect(() => {
      const coords = this.coords(); // may be null
      const isReady = this.googleMapsReady();
      if (!coords || !isReady) return;

      untracked(() => {
        const enq = this.enquiry();
        if (!enq) return;

        // check driver state - robust check
        const driverId = enq.driver_details?.id;
        const userId = this.user?.id;
        const isDriver =
          driverId && userId && String(driverId) === String(userId);

        if (!isDriver) {
          return;
        }

        const now = Date.now();

        // GeoLocationService already handles 15s/10m throttling internally.
        // We can just accept the update whenever the signal fires.
        this.acceptCoordsAndRun(coords, now);
      });
    });
  }

  private acceptCoordsAndRun(
    coords: { latitude: number; longitude: number },
    now: number
  ) {
    this.lastAcceptedCoords = { lat: coords.latitude, lng: coords.longitude };
    this.lastAcceptedTs = now;

    // run your original logic (no setInterval)
    this.driverMarker = {
      lat: coords.latitude || 0.0,
      lng: coords.longitude || 0.0,
    };

    this.updateCoveredPath(coords.latitude, coords.longitude);
    this.setValues();
  }

  /** Haversine helper — centralize to MapUtils eventually, keeping here for now */
  private haversineDistanceMeters(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number
  ) {
    return MapUtils.haversineDistanceMeters(lat1, lon1, lat2, lon2);
  }

  async ngAfterViewInit() {
    // Initialization handled by setupMapInitEffect in constructor
  }

  getDistanceFromLatLonInMeters(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number
  ): number {
    return MapUtils.haversineDistanceMeters(lat1, lon1, lat2, lon2);
  }

  async waitForGoogleMaps(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;
    return new Promise(resolve => {
      let attempts = 0;
      const checkGoogleMaps = setInterval(() => {
        attempts++;
        if (window['google'] && window['google'].maps) {
          clearInterval(checkGoogleMaps);
          resolve();
        } else if (attempts > 50) {
          clearInterval(checkGoogleMaps);
          console.warn('Google Maps failed to load within 5 seconds.');
          resolve();
        }
      }, 100);
    });
  }

  getEnquiry(openMapsIfEligible = false) {
    this._EnquiryService
      .getEnqueryById(this.enquiryId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: enquiry) => {
          this.enquiry.set(res);
          this.dataService.setData(res);
          this.statusSocket.set(res.trip_status);
          if (res.is_near_dropoff === true) {
            this.isNearDropoff.set(true);
          }
          if (
            this.enquiry().trip_status === 'ARRIVED' ||
            this.enquiry().trip_status === 'STARTED' ||
            this.enquiry().trip_status === 'PAUSED'
          ) {
            this.dataService.setSos(true);
          }
          if (this.statusSocket() === 'ENDED') {
            this.transactionPay();
          }

          // center on first location (if present)
          const firstLoc = res.locations?.[0];
          if (firstLoc) {
            this.center.set({
              lat: Number(firstLoc.lat),
              lng: Number(firstLoc.long ?? firstLoc.long ?? 0),
            });
          }

          const isRental = res.module_id === 'RENTAL';
          // Build filtered stops from enquiry.locations (server returns is_completed)
          const filteredData = (res.locations || [])
            .filter((item: any) => {
              const hasValidLatLong =
                item.lat !== undefined &&
                item.long !== undefined &&
                Number(item.lat) > 0 &&
                Number(item.long) > 0;
              const hasAddressAndId = item.address && item.id;
              const isNotCompleted = isRental
                ? true
                : item.is_completed === false;
              return hasValidLatLong && hasAddressAndId && isNotCompleted;
            })
            .map((item: any, i) => ({
              id: item.id,
              data: { lat: Number(item.lat), lng: Number(item.long) },
              address: item.address,
              index: res.locations.findIndex(x => x.id === item.id),
            }));

          // Find the last completed locationId
          const lastCompletedLocation = res.locations
            .filter((item: any) => item.is_completed === true)
            .sort((a: any, b: any) => a.index - b.index)
            .pop();

          if (lastCompletedLocation) {
            this.lastCompletedLocationId = lastCompletedLocation.id;
          }

          // immediateLocationsDirections is the single source of truth
          this.immediateLocationsDirections.set(filteredData);
          const initialStops = filteredData || [];
          let initialTarget = null;
          if (
            this.statusSocket() === 'IN-PROCESS' ||
            this.statusSocket() === 'ARRIVED'
          )
            initialTarget = initialStops.length > 0 ? 0 : null;
          else if (
            this.statusSocket() === 'STARTED' ||
            this.statusSocket() === 'PAUSED'
          )
            initialTarget =
              initialStops.length > 1
                ? 1
                : initialStops.length === 1
                  ? 0
                  : null;

          this.dataService.updateDirectionIndex(initialTarget, initialStops);
          // set originalStopsCount only the first time we receive data (used to compute dropoff numbering)
          if (this.originalStopsCount === null) {
            this.originalStopsCount = res.locations
              ? res.locations.length
              : filteredData.length;
          }

          if (
            this.immediateLocationsDirections() &&
            this.immediateLocationsDirections().length > 0
          ) {
            const last =
              this.immediateLocationsDirections()[
                this.immediateLocationsDirections().length - 1
              ].data;
            this.dropoffMarker = { lat: last.lat, lng: last.lng };
            this.mapInitializer();
            if (
              this.user?.type === 'DRIVER' ||
              String(this.enquiry()?.driver_details?.id) === this.user?.id
            ) {
              this.addLocationListeners();
            }
            this.setValues();
          }

          if (openMapsIfEligible) {
            this.openGoogleMapsToNextIncompleteStop();
          }
        },
        error: () => {
          if (openMapsIfEligible) {
            this.discardReservedGoogleMapsTab();
          }
        },
      });
  }

  mapInitializer() {
    this.options.set({
      zoom: this.zoom(),
      disableDefaultUI: true,
      zoomControl: false,
      mapTypeControl: false,
      streetViewControl: false,
    });
    this.getDirections();
  }

  onZoomChanged() {
    this.zoom.set(this.map.getZoom() ?? this.zoom());
  }

  getDirections(): void {
    const directions = this.immediateLocationsDirections();
    if (!directions || directions.length === 0) return;

    this.pickupMarker = {
      lat: directions[0].data.lat,
      lng: directions[0].data.lng,
    };

    const enq = this.enquiry();
    const currentCoords = this.coords();
    const socketCoords = this.getSocketDriverCoords();

    if (socketCoords) {
      this.driverMarker = socketCoords;
    } else if (
      this.user?.type === 'DRIVER' ||
      String(enq?.driver_details?.id) === this.user?.id
    ) {
      this.driverMarker = {
        lat: Number(currentCoords?.latitude || 0),
        lng: Number(currentCoords?.longitude || 0),
      };
    } else {
      this.driverMarker = {
        lat: Number(enq?.driver_details?.lat ?? 0),
        lng: Number(enq?.driver_details?.long ?? 0),
      };
    }

    // directions is already defined at the top of getDirections()

    if (Array.isArray(directions) && directions.length > 0) {
      const lastItem = directions[directions.length - 1];

      this.dropoffMarker = {
        lat: lastItem?.data?.lat ?? 0,
        lng: lastItem?.data?.lng ?? 0,
      };
    } else {
      // fallback in case array is empty or invalid
      this.dropoffMarker = { lat: 0, lng: 0 };
    }

    let origin = this.pickupMarker;
    let destination = this.dropoffMarker;

    if (
      this.statusSocket() === 'IN-PROCESS' ||
      this.statusSocket() === 'ARRIVED'
    ) {
      origin = this.driverMarker;
      destination = this.dropoffMarker;
    } else if (
      this.statusSocket() === 'STARTED' ||
      this.statusSocket() === 'PAUSED'
    ) {
      origin = this.driverMarker;
      destination = this.dropoffMarker;
    }

    let waypoints: google.maps.DirectionsWaypoint[] = [];

    // Create a shallow copy so original data isn't mutated
    const locations = [...directions];

    if (this.statusSocket() === 'NOT-STARTED') {
      // Remove first and last elements
      locations.shift();
      locations.pop();
    } else {
      // Remove only the last element
      locations.pop();
    }

    waypoints = locations.map(loc => ({
      location: loc.data,
      stopover: true,
    }));

    this.markers = [
      { position: origin, type: 'pickup' },
      { position: destination, type: 'dropoff' },
      ...waypoints.map(wp => ({
        position: wp.location as google.maps.LatLngLiteral, // ensure LatLngLiteral type
        type: 'waypoint',
      })),
    ];

    const updateDirection = {
      origin,
      destination,
      waypoints: locations.map(loc => ({
        lat: Number(loc.data.lat),
        lng: Number(loc.data.lng),
      })),
    };

    this.dataService.setCoordinates(updateDirection);

    const request: google.maps.DirectionsRequest = {
      origin,
      destination,
      travelMode: google.maps.TravelMode.DRIVING,
      provideRouteAlternatives: false,
      waypoints,
      optimizeWaypoints: true,
    };

    // make request
    this.mapDirectionsService.route(request).subscribe({
      next: response => {
        if (!response.result) return;
        const routePath = response.result.routes[0]?.overview_path ?? [];

        if (!this.directionsRenderer) {
          this.directionsRenderer = new google.maps.DirectionsRenderer({
            suppressMarkers: true,
            suppressPolylines: true,
          });
        }

        this.directionsRenderer.setDirections(response.result);

        // update markers + polyline & compute bounds
        this.updatePolyline(routePath);

        // Driver Marker
        if (this.statusSocket() !== 'NOT-STARTED') {
          if (!this.driverMarkerInstance) {
            this.driverMarkerInstance = new google.maps.Marker({
              position: origin,
              map: this.mapRef?.googleMap,
              icon: {
                url: this.assetsConst.trackDriver,
                scaledSize: new google.maps.Size(28, 28),
                anchor: new google.maps.Point(14, 14),
              },
            });
          } else {
            this.driverMarkerInstance.setMap(this.mapRef?.googleMap);
            this.driverMarkerInstance.setPosition(origin);
          }
        } else {
          // Explicitly hide driver marker if status is NOT-STARTED
          if (this.driverMarkerInstance) {
            this.driverMarkerInstance.setMap(null);
          }
        }
        try {
          const bounds = new google.maps.LatLngBounds();
          routePath.forEach((p: any) => bounds.extend(p));
          this.polylineBounds = bounds;
          // Apply fitBounds to fix initialization bug
          if (this.mapRef.googleMap) {
            this.mapRef.googleMap.fitBounds(bounds);
          }
        } catch (e) {
          this.polylineBounds = null;
        }

        // render per-stop markers (ensure that renderStopMarkers reads immediateLocationsDirections and filters is_completed)
        this.renderStopMarkers();
      },
      error: err => {
        console.error('getDirections route failed', err);
      },
    });
  }

  // Render stop markers using immediateLocationsDirections
  // ------------------ renderStopMarkers ------------------
  private renderStopMarkers(): void {
    const rawStops = this.immediateLocationsDirections?.() ?? [];

    // Simple cache check to minimize marker flickering
    const currentStopsHash = JSON.stringify(
      rawStops.map(s => ({
        id: s.id,
        index: s.index,
        completed: (s as any).is_completed,
      }))
    );
    if ((this as any)._lastStopsHash === currentStopsHash) {
      return;
    }
    (this as any)._lastStopsHash = currentStopsHash;

    // clear existing
    this.clearStopMarkers();

    // canonical stops and only render non-completed stops
    const stopsAll = (rawStops || []).map((s: any, idx: number) => ({
      id: s.id ?? idx,
      data: {
        lat: Number(s.data?.lat ?? s.lat ?? 0),
        lng: Number(s.data?.lng ?? s.long ?? s.lng ?? 0),
      },
      address: s.address ?? '',
      index: typeof s.index !== 'undefined' ? s.index : idx,
    }));

    stopsAll.forEach((stop, idx) => {
      const id = stop.id;
      const pos = { lat: stop.data.lat, lng: stop.data.lng };
      const isRental = this.enquiry().module_id === 'RENTAL';
      const isDropoffMarker = isRental || stop.index !== 0;

      const iconUrl = isDropoffMarker
        ? this.assetsConst.pickupImmediate
        : this.assetsConst.pickupmarker;

      const marker = new google.maps.Marker({
        position: pos,
        map: this.mapRef?.googleMap,
        icon: {
          url: iconUrl,
          scaledSize: new google.maps.Size(28, 28),
        },
        label:
          stop.index === 0 ||
          (this.originalStopsCount !== null && this.originalStopsCount <= 2)
            ? undefined
            : {
                text: String(stop.index),
                color: 'white',
                fontWeight: 'bold',
              },
      });

      const infoWindowImg = isDropoffMarker
        ? assets.onMapDropImmedidate
        : assets.onMapPickUpImmediate;

      const infoWindow = new google.maps.InfoWindow({
        content: `
    <div style="display: flex; align-items: center;">
      <img src="${infoWindowImg}" style="width:24px; height:24px; margin-right: 8px;" />
      <span style="font-size:15px; font-weight: 600;">${stop.address}</span>
    </div>
  `,
      });

      if (this.enquiry().module_id === 'RENTAL') {
        marker['title'] = this.translate.translate('LocationAddress');
      }
      this.stopMarkers.set(id, marker);
      // Optional: Show InfoWindow on marker click
      marker.addListener('click', () => {
        infoWindow.open({
          anchor: marker,
          map: this.mapRef?.googleMap,
          shouldFocus: false,
        });
      });
    });
  }

  private clearStopMarkers(): void {
    // existing clear logic for stopMarkers
    if (this.stopMarkers) {
      this.stopMarkers.forEach(m => {
        try {
          m.setMap(null);
        } catch (e) {}
      });
      this.stopMarkers.clear();
    }

    // clear waypoint markers
    if (this.waypointMarkers) {
      this.waypointMarkers.forEach(m => {
        try {
          m.setMap(null);
        } catch (e) {}
      });
      this.waypointMarkers.clear();
    }
  }

  /**
   * Request directions and render them.
   * NOTE: this function now derives the *correct* destination from immediateLocationsDirections()
   * according to current statusSocket. The passed `destination` argument is used only as a fallback.
   */
  // Updated updateDirections (drop-in replacement)
  // ------------------ updateDirections ------------------
  updateDirections(
    originParam: { lat: number; lng: number } // optional fallback
  ) {
    const enq = this.enquiry();
    const currentCoords = this.coords();
    const socketCoords = this.getSocketDriverCoords();
    if (socketCoords) {
      this.driverMarker = socketCoords;
    } else if (
      this.user?.type === 'DRIVER' ||
      String(enq?.driver_details?.id) === this.user?.id
    ) {
      this.driverMarker = {
        lat: Number(currentCoords?.latitude || 0),
        lng: Number(currentCoords?.longitude || 0),
      };
    } else {
      this.driverMarker = {
        lat: Number(originParam.lat ?? 0),
        lng: Number(originParam.lng ?? 0),
      };
    }

    const directions = this.immediateLocationsDirections();

    if (Array.isArray(directions) && directions.length > 0) {
      const lastItem = directions[directions.length - 1];

      this.dropoffMarker = {
        lat: lastItem?.data?.lat ?? 0,
        lng: lastItem?.data?.lng ?? 0,
      };
    } else {
      // fallback in case array is empty or invalid
      this.dropoffMarker = { lat: 0, lng: 0 };
    }

    let origin = this.pickupMarker;
    let destination = this.dropoffMarker;

    if (
      this.statusSocket() === 'IN-PROCESS' ||
      this.statusSocket() === 'ARRIVED'
    ) {
      origin = this.driverMarker;
      destination = this.dropoffMarker;
    } else if (
      this.statusSocket() === 'STARTED' ||
      this.statusSocket() === 'PAUSED'
    ) {
      origin = this.driverMarker;
      destination = this.dropoffMarker;
    }

    let waypoints: google.maps.DirectionsWaypoint[] = [];
    const locations = [...this.immediateLocationsDirections()];

    if (this.statusSocket() === 'NOT-STARTED') {
      locations.shift();
    }
    locations.pop(); // remove last element

    waypoints = locations.map(loc => ({
      location: loc.data,
      stopover: true,
    }));

    this.markers = [
      { position: origin, type: 'pickup' },
      { position: destination, type: 'dropoff' },
      ...waypoints.map(wp => ({
        position: wp.location as google.maps.LatLngLiteral, // ensure LatLngLiteral type
        type: 'waypoint',
      })),
    ];

    // build & send request
    const request: google.maps.DirectionsRequest = {
      origin: new google.maps.LatLng(origin.lat, origin.lng),
      destination: new google.maps.LatLng(destination.lat, destination.lng),
      travelMode: google.maps.TravelMode.DRIVING,
      provideRouteAlternatives: false,
      waypoints,
      optimizeWaypoints: true,
    };

    const updateDirection = {
      origin,
      destination,
      waypoints: locations.map(loc => ({
        lat: Number(loc.data.lat),
        lng: Number(loc.data.lng),
      })),
    };

    this.dataService.setCoordinates(updateDirection);

    this.mapDirectionsService.route(request).subscribe({
      next: response => {
        if (!response.result) return;

        const routePath = response.result.routes[0]?.overview_path ?? [];

        if (!this.directionsRenderer) {
          this.directionsRenderer = new google.maps.DirectionsRenderer({
            suppressMarkers: true,
            suppressPolylines: true,
          });
        }

        this.directionsRenderer.setDirections(response.result);

        this.updatePolyline(routePath);
        this.isRerouting = false; // Reset reroute flag after completion

        if (this.statusSocket() !== 'NOT-STARTED') {
          this.updateDriverMarker(
            new google.maps.LatLng(origin.lat, origin.lng),
            false
          );
        } else {
          // Explicitly hide driver marker if status is NOT-STARTED
          if (this.driverMarkerInstance) {
            this.driverMarkerInstance.setMap(null);
          }
        }

        try {
          const bounds = new google.maps.LatLngBounds();
          routePath.forEach(p => bounds.extend(p));
          this.polylineBounds = bounds;
          if (this.mapRef.googleMap) {
            this.mapRef.googleMap.fitBounds(bounds);
          }
        } catch {
          this.polylineBounds = null;
        }

        // refresh per-stop markers
        this.renderStopMarkers();
      },
      error: err => {
        this.isRerouting = false; // Reset reroute flag after error
        console.error('updateDirections failed', err);
      },
    });
  }

  // Defensive buildRouteKey (replace your existing buildRouteKey with this)
  private buildRouteKey(
    origin?: google.maps.LatLngLiteral | null,
    destination?: google.maps.LatLngLiteral | null,
    waypoints?: google.maps.DirectionsWaypoint[] | undefined
  ): string {
    const fmt = (n: number) => Number(n ?? 0).toFixed(6);

    const readLatLng = (loc: any): { lat: number; lng: number } => {
      if (!loc) return { lat: 0, lng: 0 };

      // google.maps.LatLng (has lat()/lng())
      if (typeof loc.lat === 'function' && typeof loc.lng === 'function') {
        try {
          return { lat: Number(loc.lat()), lng: Number(loc.lng()) };
        } catch {
          return { lat: 0, lng: 0 };
        }
      }

      // LatLngLiteral { lat: number, lng: number }
      if (
        (typeof loc.lat === 'number' || typeof loc.lat === 'string') &&
        (typeof loc.lng === 'number' || typeof loc.lng === 'string')
      ) {
        return { lat: Number(loc.lat), lng: Number(loc.lng) };
      }

      // some shapes put lat/lng under latLng
      if (loc && loc.latLng && (loc.latLng.lat || loc.latLng.lng)) {
        const a = loc.latLng;
        if (typeof a.lat === 'function' && typeof a.lng === 'function') {
          try {
            return { lat: Number(a.lat()), lng: Number(a.lng()) };
          } catch {
            return { lat: 0, lng: 0 };
          }
        }
        return { lat: Number(a.lat ?? 0), lng: Number(a.lng ?? 0) };
      }

      // array-like [lat, lng]
      if (Array.isArray(loc) && loc.length >= 2) {
        return { lat: Number(loc[0] ?? 0), lng: Number(loc[1] ?? 0) };
      }

      return { lat: 0, lng: 0 };
    };

    const o = readLatLng(origin ?? null);
    const d = readLatLng(destination ?? null);

    const wp = (waypoints || [])
      .map(w => {
        const loc = (w && (w as any).location) ?? null;
        const { lat, lng } = readLatLng(loc);
        return `${fmt(lat)},${fmt(lng)}`;
      })
      .join('|');

    return `${fmt(o.lat)},${fmt(o.lng)}__${fmt(d.lat)},${fmt(d.lng)}__${wp}`;
  }

  updatePolyline(routePath: google.maps.LatLng[]) {
    if (this.driverPolyline) {
      this.driverPolyline.setMap(null);
      this.driverPolyline = null;
    }

    this.driverPolyline = new google.maps.Polyline({
      path: routePath,
      strokeColor: '#000000',
      strokeWeight: 3,
    });

    this.driverPolyline.setMap(this.mapRef.googleMap);
  }

  setValues(): void {
    if (!this.enquiry()) return;

    // 1) run proximity/distance logic and get possible label override
    const proximity = this.showButtonAccordingToDistance();
    const computedShow = proximity.shouldShow;
    const proximityLabel = proximity.labelOverride ?? null;

    // 2) compute label based on status, but allow proximityLabel to override when provided
    let computedLabel: string | null = null;

    if (this.enquiry()?.driver_details?.driver_accepted !== true) {
      // not accepted -> hide button
      this.setButtonShow(false);
      return;
    }

    if (
      !(
        this.user?.type === 'DRIVER' ||
        String(this.enquiry()?.driver_details?.id) === this.user?.id
      )
    ) {
      // not the driver: hide button
      this.setButtonShow(false);
      return;
    }

    // If proximity provided a label (e.g. near pickup), prefer it
    if (proximityLabel) {
      computedLabel = proximityLabel;
    } else {
      // else compute label from status and stops
      switch (this.statusSocket()) {
        case 'NOT-STARTED': {
          const locs = this.enquiry()?.locations;
          if (locs && locs.length <= 2) {
            computedLabel = this.translate.translate('goToPick');
          } else {
            computedLabel = this.translate.translate('goToPickupPoint');
          }
          break;
        }
        case 'IN-PROCESS':
        case 'ARRIVED': {
          if (
            this.enquiry()?.locations &&
            this.enquiry()!.locations.length > 2
          ) {
          } else {
            computedLabel = this.translate.translate('start_ride');
          }

          break;
        }
        case 'STARTED':
        case 'PAUSED': {
          const nextDropNumber = this.immediateLocationsDirections()[0].index;
          const locs = this.enquiry()?.locations;
          if (locs && locs.length === 2) {
            computedLabel = this.translate.translate('ridecomplete');
          } else if (
            this.enquiry()?.locations &&
            this.enquiry()!.locations.length > 2
          ) {
            if (this.immediateLocationsDirections().length === 1) {
              computedLabel = this.translate.translate('ridecomplete');
            } else {
              computedLabel =
                this.translate.translate('gotothedropoff') +
                ` ${nextDropNumber}`;
            }
          }

          break;
        }
        default: {
          computedLabel = '';
        }
      }
    }

    // 3) apply computed show + label only when changed (cached setters)
    this.setButtonLabel(computedLabel);
    this.setButtonShow(computedShow);

    // 4) next stop hint (unchanged logic) — only update when different
    const stops = this.immediateLocationsDirections() || [];
    let nextAddr: string | null = null;
    if (
      this.statusSocket() === 'NOT-STARTED' ||
      this.statusSocket() === 'IN-PROCESS' ||
      this.statusSocket() === 'ARRIVED'
    ) {
      nextAddr =
        stops.length > 0 ? this.shortenAddress(stops[0].address) : null;
    } else if (
      this.statusSocket() === 'STARTED' ||
      this.statusSocket() === 'PAUSED'
    ) {
      const next = stops.length > 1 ? stops[1] : stops[0];
      nextAddr = next ? this.shortenAddress(next.address) : null;
    }
    this.setNextStopAddress(nextAddr);
  }

  /**
   * Decide whether button should be shown given current status & proximity.
   * Returns an object { shouldShow, labelOverride? }.
   * labelOverride is used by setValues() to decide a proximity-driven label
   * (e.g. 'trip_start' when within 250m of pickup).
   */
  showButtonAccordingToDistance(): {
    shouldShow: boolean;
    labelOverride?: string | null;
  } {
    let shouldShow = false;
    let labelOverride: string | null | undefined = undefined;

    const moduleId = this.enquiry()?.module_id;

    if (!moduleId) {
      // fallback: don't show
      return { shouldShow: false };
    }

    switch (moduleId) {
      case 'TRANSPORT':
      case 'DELIVERY': {
        switch (this.statusSocket()) {
          case 'NOT-STARTED': {
            // Trips start from Enquiry Details ("Go To Pickup").
            shouldShow = false;
            break;
          }
          case 'IN-PROCESS':
          case 'ARRIVED': {
            const target = this.getCurrentTargetForButton();
            const canShow = this.showButton(this.driverMarker, target);
            shouldShow = true;
            // proximity label override: when driver is near pickup we want label 'trip_start'
            if (canShow) {
              // pick stops info to decide labelOverride
              const stops = this.immediateLocationsDirections() || [];
              const original = this.originalStopsCount ?? stops.length;
              const totalDropoffs = Math.max(0, original - 1);

              // edge-case: no pickup address available — behave like STARTED
              const completedStops = Math.max(0, original - stops.length);
              let nextDropNumber = completedStops > 0 ? completedStops : 1;
              nextDropNumber = Math.min(
                Math.max(1, nextDropNumber),
                Math.max(1, totalDropoffs)
              );

              const locs = this.enquiry()?.locations;
              if (locs && locs.length > 2) {
                labelOverride =
                  this.translate.translate('gotothedropoff') + ' 1';
              } else {
                labelOverride = this.translate.translate('start_ride');
              }

              // also emit position once
              this.position(true);
            } else {
              // not near
              // yet, keep default pickup label (no override)
              shouldShow = false;
              this.position(false);
            }
            break;
          }
          case 'STARTED':
          case 'PAUSED': {
            // canonical stops (whatever immediateLocationsDirections returns)
            const canonical = (
              this.getCanonicalStopsForUI() ??
              this.immediateLocationsDirections() ??
              []
            ).map((s: any, idx: number) => ({
              id: s.id ?? idx,
              data: s.data
                ? {
                    lat: Number(s.data.lat),
                    lng: Number(s.data.lng ?? s.data.long ?? 0),
                  }
                : {
                    lat: Number(s.lat ?? 0),
                    lng: Number(s.long ?? s.lng ?? 0),
                  },
              index: typeof s.index !== 'undefined' ? s.index : idx,
            }));

            // detect if canonical includes pickup at index 0; if yes, originalDrops = slice(1), otherwise canonical is drops-only

            const tolPickup = 1e-4; // ~11m
            let canonicalIncludesPickup = false;

            if (canonical.length > 0 && this.pickupMarker) {
              const first = canonical[0].data;
              if (
                Math.abs(first.lat - (this.pickupMarker.lat ?? 0)) <
                  tolPickup &&
                Math.abs(first.lng - (this.pickupMarker.lng ?? 0)) < tolPickup
              ) {
                canonicalIncludesPickup = true;
              }
              if (canonical[0].index === 0) canonicalIncludesPickup = true;
            }
            // target helper and driver position
            const target = this.getCurrentTargetForButton();

            const canShow = this.showButton(this.driverMarker, target);
            const isLastDropoff = canonical.length === 1;
            shouldShow = canShow || (isLastDropoff && this.isNearDropoff());

            if (shouldShow) {
              labelOverride = isLastDropoff
                ? this.translate.translate('ridecomplete')
                : this.getDropoffButtonLabel(target);
            }
            this.position(canShow);

            break;
          }

          default: {
            shouldShow = false;
          }
        }
        break;
      }
      case 'RENTAL': {
        switch (this.statusSocket()) {
          case 'IN-PROCESS':
          case 'ARRIVED': {
            if (
              this.user?.type === 'DRIVER' ||
              this.enquiry().driver_details.id === this.user.id
            ) {
              this.position(true);
              shouldShow = true;
            } else {
              this.position(false);
              shouldShow = false;
            }
            break;
          }
          case 'STARTED':
          case 'PAUSED': {
            // canonical stops (whatever immediateLocationsDirections returns)
            const canonical = (
              this.getCanonicalStopsForUI() ??
              this.immediateLocationsDirections() ??
              []
            ).map((s: any, idx: number) => ({
              id: s.id ?? idx,
              data: s.data
                ? {
                    lat: Number(s.data.lat),
                    lng: Number(s.data.lng ?? s.data.long ?? 0),
                  }
                : {
                    lat: Number(s.lat ?? 0),
                    lng: Number(s.long ?? s.lng ?? 0),
                  },
              index: typeof s.index !== 'undefined' ? s.index : idx,
            }));

            // detect if canonical includes pickup at index 0; if yes, originalDrops = slice(1), otherwise canonical is drops-only

            const tolPickup = 1e-4; // ~11m
            let canonicalIncludesPickup = false;

            if (canonical.length > 0 && this.pickupMarker) {
              const first = canonical[0].data;
              if (
                Math.abs(first.lat - (this.pickupMarker.lat ?? 0)) <
                  tolPickup &&
                Math.abs(first.lng - (this.pickupMarker.lng ?? 0)) < tolPickup
              ) {
                canonicalIncludesPickup = true;
              }
              if (canonical[0].index === 0) canonicalIncludesPickup = true;
            }
            // target helper and driver position
            const target = this.getCurrentTargetForButton();

            const canShow = this.showButton(this.driverMarker, target);
            const isLastDropoff = canonical.length === 1;
            shouldShow = canShow || (isLastDropoff && this.isNearDropoff());

            if (shouldShow) {
              labelOverride = isLastDropoff
                ? this.translate.translate('ridecomplete')
                : this.getDropoffButtonLabel(target);
            }
            this.position(canShow);

            break;
          }
        }
        break;
      }
      default: {
        shouldShow = false;
      }
    }

    // return both decisions - labelOverride may be undefined (no override)
    return { shouldShow, labelOverride };
  }

  private getCurrentTargetForButton(): google.maps.LatLngLiteral | null {
    const stops = this.getCanonicalStopsForUI();
    if (!stops || stops.length === 0) {
      // fallback
      if (this.dropoffMarker)
        return {
          lat: Number(this.dropoffMarker.lat ?? 0),
          lng: Number(this.dropoffMarker.lng ?? 0),
        };
      return null;
    }

    // pickup = index 0
    const pickup = stops[0];

    // if still heading to pickup, target is pickup
    if (
      this.statusSocket() === 'NOT-STARTED' ||
      this.statusSocket() === 'IN-PROCESS' ||
      this.statusSocket() === 'ARRIVED'
    ) {
      return pickup?.data ?? null;
    }

    // if started: find first not-completed drop (skip pickup)
    const drops = stops;
    let firstNotCompleted;
    if (this.enquiry()?.module_id === 'RENTAL') {
      firstNotCompleted = drops.find(s => s.is_completed);
    } else {
      firstNotCompleted = drops.find(s => !s.is_completed);
    }
    if (drops && firstNotCompleted) return firstNotCompleted.data;

    // if all drops completed, fallback to last drop (or pickup)
    if (drops.length > 0) return drops[drops.length - 1].data;
    return pickup?.data ?? null;
  }

  position(near_to_location: boolean, forceEmit = false): void {
    const enq = this.enquiry();
    const driverId = enq?.driver_details?.id;
    const userId = this.user?.id;
    const isDriver = driverId && userId && String(driverId) === String(userId);

    if (isDriver) {
      const now = Date.now();
      // Only throttle if not forced (forced used for status changes)
      if (!forceEmit && now - this.lastEmitTimestamp < 10000) {
        return;
      }

      const markerPosition = this.resolveDriverMarkerPosition();
      if (!markerPosition) {
        return;
      }

      const payload: positionTracking = {
        lat: markerPosition.lat,
        long: markerPosition.lng,
        payload: {
          token: this.enquiry()?.token ?? '',
          status: this.statusSocket(),
        },
        trip_id: Number(this.enquiry()?.trip_id ?? 0),
      };
      if (near_to_location) {
        payload['near_to_location'] = near_to_location;
      }

      if (this.eta() > 0) {
        payload['eta'] = this.eta();
      }
      if (this.distance() > 0) {
        payload['pending_distance'] = this.distance();
      }
      this._socket.sendPositionTracking(payload);
      this.lastEmitTimestamp = now;
    }
  }

  private resolveDriverMarkerPosition(): google.maps.LatLngLiteral | null {
    const markerLat = Number(this.driverMarker?.lat);
    const markerLng = Number(this.driverMarker?.lng);
    if (Number.isFinite(markerLat) && Number.isFinite(markerLng)) {
      return { lat: markerLat, lng: markerLng };
    }

    const liveCoords = this.coords();
    const liveLat = Number(liveCoords?.latitude);
    const liveLng = Number(liveCoords?.longitude);
    if (Number.isFinite(liveLat) && Number.isFinite(liveLng)) {
      return { lat: liveLat, lng: liveLng };
    }

    const enq = this.enquiry();
    const apiLat = Number(enq?.driver_details?.lat);
    const apiLng = Number(enq?.driver_details?.long);
    if (Number.isFinite(apiLat) && Number.isFinite(apiLng)) {
      return { lat: apiLat, lng: apiLng };
    }

    return null;
  }

  addLocationListeners(): void {
    if (this.enquiry()) {
      const payload: joinTrip = {
        trip_id: this.enquiry().trip_id,
        enquiry_id: this.enquiry().id,
      };
      this._socket.joinTripTracking(payload).subscribe({
        next: response => {
          if (response.status) {
            this._socket
              .trackingListner()
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((res: DriverLoc) => {
                if (
                  res.action === 'DRIVER_ASSIGN' &&
                  (this.user?.type === 'DRIVER' ||
                    String(this.enquiry()?.driver_details?.id) ===
                      this.user?.id)
                ) {
                  this.router.navigate(['/sp-bids/sp-auctions']);
                } else if (res.action === 'DRIVER_ASSIGN') {
                  this.getEnquiry();
                }

                if (
                  res.payload.status === 'ARRIVED' ||
                  res.payload.status === 'STARTED' ||
                  res.payload.status === 'PAUSED'
                ) {
                  this.dataService.setSos(true);
                }

                this.trackingSocketService.setTrackingSocket(res);
                const nearDropoff = res.is_near_dropoff === true;
                const nearDropoffChanged = this.isNearDropoff() !== nearDropoff;
                this.isNearDropoff.set(nearDropoff);
                const lat = Number(res.lat);
                const lng = Number(res.long);

                if (isFinite(lat) && isFinite(lng)) {
                  this.lastDriverLatLng = { lat, lng };
                  this.center.set({ lat, lng });
                  this.driverMarker = { lat, lng };
                }

                this.lastLabel = null;
                this.lastShow = null;
                this.lastNextAddr = null;
                if (res.location_id) {
                  this.immediateLocationsDirections.update(list =>
                    list.filter((val: any) => val.id != res.location_id)
                  );
                  // Force redraw of stops and route to the next destination
                  this.renderStopMarkers();
                  const latVal = Number(res.lat);
                  const lngVal = Number(res.long);
                  if (isFinite(latVal) && isFinite(lngVal)) {
                    this.updateDirections({ lat: latVal, lng: lngVal });
                  }
                }

                if (this.statusSocket() !== res.payload.status) {
                  this.statusSocket.set(res.payload.status);
                  // Sync current target index depending on new status
                  const stops = this.immediateLocationsDirections() || [];
                  let targetIndex: number | null = null;

                  if (
                    this.statusSocket() === 'IN-PROCESS' ||
                    this.statusSocket() === 'ARRIVED'
                  ) {
                    // heading to pickup -> target is index 0
                    targetIndex = stops.length > 0 ? 0 : null;
                  } else if (
                    this.statusSocket() === 'STARTED' ||
                    this.statusSocket() === 'PAUSED'
                  ) {
                    // after pickup, next target is index 1 (first drop) if exists; else null
                    targetIndex =
                      stops.length > 1 ? 1 : stops.length === 1 ? 0 : null;
                  } else {
                    targetIndex = null;
                  }

                  this.dataService.updateDirectionIndex(targetIndex);
                  if (res.payload.status === 'ENDED') {
                    this.transactionPay();
                  } else {
                    this.updateDirections(this.driverMarker);
                  }
                } else {
                  this.updateCoveredPath(res.lat, res.long);
                }
                if (nearDropoffChanged) {
                  this.setValues();
                }
              });
          }
        },
      });
    }
  }

  private showButton(
    origin: { lat: number; lng: number } | null | undefined,
    target: { lat: number; lng: number } | null | undefined,
    proximityMeters?: number
  ): boolean {
    if (!origin || !target) {
      return false;
    }

    const threshold =
      typeof proximityMeters === 'number'
        ? proximityMeters
        : typeof this.buttonProximityMeters === 'number'
          ? this.buttonProximityMeters
          : 250;

    try {
      const o = { lat: Number(origin.lat ?? 0), lng: Number(origin.lng ?? 0) };
      const t = { lat: Number(target.lat ?? 0), lng: Number(target.lng ?? 0) };

      const dist = this.distanceBetween(o, t); // should return meters

      // debug log to help trace why canShow is fals
      return typeof dist === 'number' && dist <= threshold;
    } catch (e) {
      return false;
    }
  }

  // driver button click flow
  handleDriverButtonClick(): void {
    if (!this.enquiry()) return;

    if (this.shouldReserveGoogleMapsTab(this.statusSocket())) {
      this.reserveGoogleMapsTab();
    }

    switch (this.statusSocket()) {
      case 'NOT-STARTED': {
        const status = 'IN-PROCESS';
        this._TripsService
          .tripStatus({ status }, this.enquiry()!.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: () => {
              this.statusSocket.set(status);
              this.setButtonShow(false);
              this.getEnquiry(true);
            },
            error: err => {
              this.discardReservedGoogleMapsTab();
              console.error(
                'tripStatus (NOT-STARTED -> IN-PROCESS) failed',
                err
              );
            },
          });
        break;
      }

      case 'IN-PROCESS':
      case 'ARRIVED': {
        const stops = this.immediateLocationsDirections();
        const enq = this.enquiry();
        if (!stops || stops.length === 0 || !enq) {
          this.discardReservedGoogleMapsTab();
          return;
        }
        const pickupLoc = stops[0];
        if (!pickupLoc) {
          this.discardReservedGoogleMapsTab();
          return;
        }

        // RENTAL: skip completeLocation — only transition trip to STARTED
        if (enq.module_id === 'RENTAL') {
          this.startTripStatus();
        } else {
          this.markLocationCompletedAndStartTrip(pickupLoc.id);
        }
        break;
      }

      case 'STARTED':
      case 'PAUSED': {
        const stops: any = this.immediateLocationsDirections();
        if (!stops || stops.length === 0) {
          this.discardReservedGoogleMapsTab();
          return;
        }

        let dropCandidate;
        // prefer: first drop after pickup (index > 0) that is not completed
        if (this.enquiry()?.module_id === 'RENTAL') {
          dropCandidate = stops.find((s: any, i: number) => s.is_completed);
        } else {
          dropCandidate = stops.find((s: any, i: number) => !s.is_completed);
        }

        // fallback: first non-completed location anywhere (defensive)
        if (!dropCandidate) {
          if (this.enquiry()?.module_id === 'RENTAL') {
            dropCandidate = stops.find((s: any) => s.is_completed);
          } else {
            dropCandidate = stops.find((s: any) => !s.is_completed);
          }
        }

        // last fallback: take last element (defensive)
        if (!dropCandidate) {
          dropCandidate = stops[stops.length - 1];
        }

        if (!dropCandidate) {
          this.discardReservedGoogleMapsTab();
          return;
        }
        this.markLocationCompletedAndMaybeEndTrip(dropCandidate.id);
        break;
      }

      default:
        break;
    }
  }

  private shouldOpenGoogleMapsForStatus(status: string): boolean {
    return (
      status === 'IN-PROCESS' || status === 'ARRIVED' || status === 'STARTED'
    );
  }

  private shouldReserveGoogleMapsTab(status: string): boolean {
    if (
      status === 'NOT-STARTED' ||
      status === 'IN-PROCESS' ||
      status === 'ARRIVED'
    ) {
      return true;
    }

    if (status === 'STARTED') {
      const remainingStops = this.immediateLocationsDirections() ?? [];
      return remainingStops.length > 1;
    }

    return false;
  }

  private reserveGoogleMapsTab(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.discardReservedGoogleMapsTab();
    this.pendingMapsTab = window.open('about:blank', '_blank');
  }

  private discardReservedGoogleMapsTab(): void {
    if (this.pendingMapsTab && !this.pendingMapsTab.closed) {
      this.pendingMapsTab.close();
    }
    this.pendingMapsTab = null;
  }

  /** Opens Google Maps to the first incomplete stop (Android navigateToMap). */
  private openGoogleMapsToNextIncompleteStop(): void {
    if (!isPlatformBrowser(this.platformId)) {
      this.discardReservedGoogleMapsTab();
      return;
    }

    if (!this.shouldOpenGoogleMapsForStatus(this.statusSocket())) {
      this.discardReservedGoogleMapsTab();
      return;
    }

    const destination = this.getFirstIncompleteStopCoords();
    const origin =
      this.getSocketDriverCoords() ?? this.getLiveGeoDriverCoords();
    if (!destination || !origin) {
      this.discardReservedGoogleMapsTab();
      return;
    }

    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&travelmode=driving`;
    if (this.pendingMapsTab && !this.pendingMapsTab.closed) {
      this.pendingMapsTab.location.href = googleMapsUrl;
    } else {
      window.open(googleMapsUrl, '_blank');
    }
    this.pendingMapsTab = null;
  }

  private getSocketDriverCoords(): { lat: number; lng: number } | null {
    const socket = this.lastDriverLatLng;
    if (socket && Number.isFinite(socket.lat) && Number.isFinite(socket.lng)) {
      return { lat: socket.lat, lng: socket.lng };
    }
    return null;
  }

  private getLiveGeoDriverCoords(): { lat: number; lng: number } | null {
    const live = this.coords();
    const lat = Number(live?.latitude);
    const lng = Number(live?.longitude);
    if (
      Number.isFinite(lat) &&
      Number.isFinite(lng) &&
      lat !== 0 &&
      lng !== 0
    ) {
      return { lat, lng };
    }
    return null;
  }

  private getFirstIncompleteStopCoords(): {
    lat: number;
    lng: number;
  } | null {
    const fromEnquiry = this.enquiry()?.locations?.find(loc => {
      const lat = Number(loc.lat);
      const lng = Number(loc.long);
      return (
        loc.is_completed === false &&
        Number.isFinite(lat) &&
        Number.isFinite(lng) &&
        lat > 0 &&
        lng > 0
      );
    });

    if (fromEnquiry) {
      return {
        lat: Number(fromEnquiry.lat),
        lng: Number(fromEnquiry.long),
      };
    }

    const fallback = this.immediateLocationsDirections()?.[0]?.data;
    if (
      fallback &&
      Number.isFinite(fallback.lat) &&
      Number.isFinite(fallback.lng) &&
      fallback.lat > 0 &&
      fallback.lng > 0
    ) {
      return fallback;
    }

    return null;
  }

  /** Transitions trip status IN-PROCESS/ARRIVED → STARTED (no location completion). */
  private startTripStatus(): void {
    const enquiryId = this.enquiry()?.id;
    if (!enquiryId) {
      this.discardReservedGoogleMapsTab();
      return;
    }

    const status = 'STARTED';
    this._TripsService
      .tripStatus({ status }, enquiryId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.statusSocket.set(status);
          this.setButtonShow(false);
          this.getEnquiry(true);
        },
        error: err => {
          this.discardReservedGoogleMapsTab();
          console.error('tripStatus (IN-PROCESS -> STARTED) failed', err);
        },
      });
  }

  private markLocationCompletedAndStartTrip(locationId: number): void {
    const stopsBefore = this.immediateLocationsDirections() || [];
    this.completeLocationApi(locationId).subscribe({
      next: () => {
        this.lastCompletedLocationId = locationId;
        this.applyLocalLocationCompletion(locationId);

        // compute index of the completed location in the old list
        const completedIndex = stopsBefore.findIndex(s => s.id === locationId);
        // if not found, set null
        const idx = completedIndex >= 0 ? completedIndex : null;

        // update service: mark that index as completed and set current target
        // pass stopsBefore so service can record the completed stop
        this.dataService.updateDirectionIndex(idx, stopsBefore);

        this.startTripStatus();
      },
      error: err => {
        this.discardReservedGoogleMapsTab();
        console.error('completeLocation (pickup) failed', err);
      },
    });
  }

  private markLocationCompletedAndMaybeEndTrip(locationId: number): void {
    const stopsBefore = this.immediateLocationsDirections() || [];
    this.completeLocationApi(locationId).subscribe({
      next: () => {
        const newStops = this.applyLocalLocationCompletion(locationId);
        this.lastCompletedLocationId = locationId;
        // compute index for completed drop
        const completedIndex = stopsBefore.findIndex(s => s.id === locationId);
        const idx = completedIndex >= 0 ? completedIndex : null;

        // tell service this index completed
        this.dataService.updateDirectionIndex(idx, stopsBefore);
        if (!newStops || newStops.length === 0) {
          this.discardReservedGoogleMapsTab();
          const status = 'ENDED';
          const enqId = this.enquiry()?.id;
          if (!enqId) return;
          this._TripsService
            .tripStatus({ status }, enqId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: () => {
                this.statusSocket.set(status);
                this.setButtonShow(false);
                this.position(false);
                if (this.statusSocket() === 'ENDED') {
                  this.transactionPay();
                }
              },
            });
        } else {
          this.getEnquiry(true);
        }
      },
      error: err => {
        this.discardReservedGoogleMapsTab();
        console.error('completeLocation (dropoff) failed', err);
      },
    });
  }

  // Reusable API caller - centralize the actual API call
  private completeLocationApi(locationId: number) {
    // Adjust this call to match your actual service signature if needed.
    return this._TripsService
      .completeLocation({ is_completed: true }, locationId)
      .pipe(takeUntilDestroyed(this.destroyRef));
  }

  // Reusable local update after server confirms completion
  private applyLocalLocationCompletion(locationId: number) {
    const marker = this.stopMarkers.get(locationId);
    if (marker) {
      try {
        marker.setMap(null);
      } catch (e) {}
      this.stopMarkers.delete(locationId);
    }

    const stops = this.immediateLocationsDirections() || [];
    const newStops = stops.filter(s => s.id !== locationId);
    this.immediateLocationsDirections.set(newStops);

    return newStops;
  }

  // class-level variable (important)
  private nearStartHitCount = 0;

  private isPointOnPath(driverLat: number, driverLng: number): boolean {
    if (!this.driverPolyline) return false;

    const path = this.driverPolyline.getPath();
    if (!path || path.getLength() === 0) return false;

    const startPoint = path.getAt(0);
    const driverPoint = new google.maps.LatLng(driverLat, driverLng);

    const distanceMeters =
      google.maps.geometry.spherical.computeDistanceBetween(
        driverPoint,
        startPoint
      );

    // 🔑 realistic GPS tolerance
    const MAX_DISTANCE_METERS = 30;

    // ✅ stability against GPS jitter
    if (distanceMeters <= MAX_DISTANCE_METERS) {
      this.nearStartHitCount++;
    } else {
      this.nearStartHitCount = 0;
    }

    // require 2 consecutive confirmations
    return this.nearStartHitCount >= 2;
  }

  // visualization helpers
  private getRotatedCarIcon(heading: number): string {
    const rotation = heading + 90;
    const svgSize = 48;
    const centerX = 24;
    const centerY = 24;
    // The car is 40x21. Center it in the 48x48 box.
    const offsetX = (svgSize - 40) / 2; // 4
    const offsetY = (svgSize - 21) / 2; // 13.5

    const svg = `
      <svg width="${svgSize}" height="${svgSize}" viewBox="0 0 ${svgSize} ${svgSize}" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="rotate(${rotation}, ${centerX}, ${centerY})">
          <g transform="translate(${offsetX}, ${offsetY})">
            ${this.carSvgPaths}
          </g>
        </g>
      </svg>
    `;
    if (typeof btoa === 'function') {
      try {
        const encoded = btoa(unescape(encodeURIComponent(svg)));
        return `data:image/svg+xml;base64,${encoded}`;
      } catch (e) {
        return `data:image/svg+xml;base64,${btoa(svg)}`;
      }
    }
    return '';
  }

  private animateMarkerAlongPath(
    marker: google.maps.Marker,
    from: google.maps.LatLng,
    to: google.maps.LatLng,
    followPath: boolean = true
  ): void {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }

    const duration = 1000; // ms
    const startTime = performance.now();

    const segments = followPath
      ? this.getPathSegmentsBetween(from, to)
      : [from, to];
    const distances: number[] = [0];
    let totalDistance = 0;

    for (let i = 0; i < segments.length - 1; i++) {
      const d = google.maps.geometry.spherical.computeDistanceBetween(
        segments[i],
        segments[i + 1]
      );
      totalDistance += d;
      distances.push(totalDistance);
    }

    if (totalDistance === 0) {
      marker.setPosition(to);
      return;
    }

    let lastActiveHeading: number | null = null;

    const animate = (now: number) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const currentDistance = progress * totalDistance;

      let segIdx = 0;
      for (let i = 0; i < segments.length - 1; i++) {
        if (currentDistance <= distances[i + 1]) {
          segIdx = i;
          break;
        }
      }

      const segStart = segments[segIdx];
      const segEnd = segments[segIdx + 1];
      const segDist = distances[segIdx + 1] - distances[segIdx];
      const segProgress =
        segDist > 0 ? (currentDistance - distances[segIdx]) / segDist : 1;

      const current = google.maps.geometry.spherical.interpolate(
        segStart,
        segEnd,
        segProgress
      );
      const heading = google.maps.geometry.spherical.computeHeading(
        segStart,
        segEnd
      );

      if (heading !== lastActiveHeading) {
        lastActiveHeading = heading;
        marker.setIcon({
          url: this.getRotatedCarIcon(heading),
          scaledSize: new google.maps.Size(48, 48),
          anchor: new google.maps.Point(24, 24),
        });
      }

      marker.setPosition(current);

      if (this.isAutoPanning && this.mapRef?.googleMap) {
        this.mapRef.googleMap.setCenter(current);
      }

      if (progress < 1) {
        this.animationFrameId = requestAnimationFrame(animate);
      }
    };

    this.animationFrameId = requestAnimationFrame(animate);
  }

  private getPathSegmentsBetween(
    from: google.maps.LatLng,
    to: google.maps.LatLng
  ): google.maps.LatLng[] {
    if (!this.driverPolyline) return [from, to];

    const path = this.driverPolyline.getPath().getArray();
    if (path.length < 2) return [from, to];

    const findSegmentIndex = (p: google.maps.LatLng) => {
      let bestIdx = 0;
      let minD = Infinity;
      const searchLimit = Math.min(path.length - 1, 15);
      for (let i = 0; i < searchLimit; i++) {
        const proj = this.projectPointOnSegment(p, path[i], path[i + 1]);
        const d = google.maps.geometry.spherical.computeDistanceBetween(
          p,
          proj
        );
        if (d < minD) {
          minD = d;
          bestIdx = i;
        }
        if (minD < 20) {
          break; // Optimization: prevent jumping across intersecting loops
        }
      }
      return bestIdx;
    };

    const idxFrom = findSegmentIndex(from);
    const idxTo = findSegmentIndex(to);

    const segments: google.maps.LatLng[] = [from];

    if (idxFrom === idxTo) {
      segments.push(to);
    } else if (idxFrom < idxTo) {
      for (let i = idxFrom + 1; i <= idxTo; i++) {
        segments.push(path[i]);
      }
      segments.push(to);
    } else {
      // Re-route or backward snap fallback
      for (let i = idxFrom; i > idxTo; i--) {
        segments.push(path[i]);
      }
      segments.push(to);
    }

    return segments;
  }

  private projectPointOnSegment(
    p: google.maps.LatLng,
    a: google.maps.LatLng,
    b: google.maps.LatLng
  ): google.maps.LatLng {
    const headingAB = google.maps.geometry.spherical.computeHeading(a, b);
    const headingAP = google.maps.geometry.spherical.computeHeading(a, p);

    const distAP = google.maps.geometry.spherical.computeDistanceBetween(a, p);
    const distAB = google.maps.geometry.spherical.computeDistanceBetween(a, b);

    const projection =
      distAP * Math.cos(((headingAP - headingAB) * Math.PI) / 180);

    const t = Math.max(0, Math.min(1, projection / distAB));

    return google.maps.geometry.spherical.interpolate(a, b, t);
  }

  private updateCoveredPath(driverLat: number, driverLng: number): void {
    if (!this.driverPolyline) return;

    const driverLocation = new google.maps.LatLng(driverLat, driverLng);

    // Calculate distance to snapped path to determine if off-route
    const snappedPoint = this.getSnappedPointToPolyline(driverLocation);
    const distanceFromRoute =
      google.maps.geometry.spherical.computeDistanceBetween(
        driverLocation,
        snappedPoint
      );

    // Trigger re-route if driver deviates significantly (e.g. >100m) or moves out of map bounds
    const isOutOfBounds =
      this.polylineBounds && !this.polylineBounds.contains(driverLocation);

    if (distanceFromRoute > 100 || isOutOfBounds) {
      const now = Date.now();
      if (!this.isRerouting && now - this.lastRerouteTs > 10000) {
        this.isRerouting = true;
        this.lastRerouteTs = now;
        this.driverMarker = {
          lat: Number(driverLat ?? 0),
          lng: Number(driverLng ?? 0),
        };
        // Use originParam to force refresh
        this.updateDirections({ lat: driverLat, lng: driverLng });
      }

      // Update marker with actual location, not snapped, because they are off-route
      this.updateDriverMarker(driverLocation, false);
    } else {
      // Always update the marker positioning, snapped to route for smooth UI updates
      this.updateDriverMarker(driverLocation, true);
    }
  }

  private updateDriverMarker(
    position: google.maps.LatLng,
    shouldSnap: boolean = true
  ): void {
    if (this.statusSocket() === 'NOT-STARTED') {
      if (this.driverMarkerInstance) {
        this.driverMarkerInstance.setMap(null);
      }
      return;
    }

    const targetPosition = shouldSnap
      ? this.getSnappedPointToPolyline(position)
      : position;

    if (!this.driverMarkerInstance) {
      this.driverMarkerInstance = new google.maps.Marker({
        position: targetPosition,
        map: this.mapRef.googleMap!,
        zIndex: 2,
        icon: {
          url: this.getRotatedCarIcon(0), // Default heading
          scaledSize: new google.maps.Size(48, 48),
          anchor: new google.maps.Point(24, 24),
        },
      });

      return;
    }

    // Ensure marker is visible if we were previously in NOT-STARTED
    if (this.driverMarkerInstance.getMap() === null) {
      this.driverMarkerInstance.setMap(this.mapRef.googleMap!);
    }

    const currentPos =
      (this.driverMarkerInstance.getPosition() as google.maps.LatLng) ||
      targetPosition;

    this.animateMarkerAlongPath(
      this.driverMarkerInstance,
      currentPos,
      targetPosition,
      shouldSnap
    );

    // Update covered path once per API/socket update instead of 60fps
    this.updatePolylinePath(targetPosition);
  }

  private getSnappedPointToPolyline(
    position: google.maps.LatLng
  ): google.maps.LatLng {
    if (!this.driverPolyline) return position;

    const path = this.driverPolyline.getPath().getArray();
    let closestPoint = position;
    let minDistance = Number.MAX_VALUE;

    for (let i = 0; i < path.length - 1; i++) {
      const segmentStart = path[i];
      const segmentEnd = path[i + 1];

      const headingToPosition = google.maps.geometry.spherical.computeHeading(
        segmentStart,
        position
      );
      const headingToSegmentEnd = google.maps.geometry.spherical.computeHeading(
        segmentStart,
        segmentEnd
      );
      const segmentLength =
        google.maps.geometry.spherical.computeDistanceBetween(
          segmentStart,
          segmentEnd
        );
      const distanceToStart =
        google.maps.geometry.spherical.computeDistanceBetween(
          segmentStart,
          position
        );

      const projection =
        distanceToStart *
        Math.cos(((headingToPosition - headingToSegmentEnd) * Math.PI) / 180);

      const t = Math.max(0, Math.min(1, projection / segmentLength));
      const projected = google.maps.geometry.spherical.interpolate(
        segmentStart,
        segmentEnd,
        t
      );
      const distance = google.maps.geometry.spherical.computeDistanceBetween(
        position,
        projected
      );

      if (distance < minDistance) {
        minDistance = distance;
        closestPoint = projected;
      }
      if (minDistance < 20) {
        break; // Stop looking further ahead to prevent jumping across intersecting loops
      }
    }

    return closestPoint;
  }

  private updatePolylinePath(currentPosition: google.maps.LatLng): void {
    if (!this.driverPolyline) return;

    const originalPath = this.driverPolyline.getPath().getArray();
    if (originalPath.length < 2) return;

    let closestIndex = -1;
    let minDistance = Number.MAX_VALUE;
    let closestPointOnSegment: google.maps.LatLng | null = null;

    for (let i = 0; i < originalPath.length - 1; i++) {
      const start = originalPath[i];
      const end = originalPath[i + 1];

      const headingToCurrent = google.maps.geometry.spherical.computeHeading(
        start,
        currentPosition
      );
      const headingToEnd = google.maps.geometry.spherical.computeHeading(
        start,
        end
      );
      const segmentLength =
        google.maps.geometry.spherical.computeDistanceBetween(start, end);
      const distanceToStart =
        google.maps.geometry.spherical.computeDistanceBetween(
          start,
          currentPosition
        );

      const projection =
        distanceToStart *
        Math.cos(((headingToCurrent - headingToEnd) * Math.PI) / 180);

      const t = Math.max(0, Math.min(1, projection / segmentLength));
      const projectedPoint = google.maps.geometry.spherical.interpolate(
        start,
        end,
        t
      );
      const distance = google.maps.geometry.spherical.computeDistanceBetween(
        currentPosition,
        projectedPoint
      );

      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = i;
        closestPointOnSegment = projectedPoint;
      }
      if (minDistance < 20) {
        break; // Stop looking further ahead to prevent cutting off early segments on loops
      }
    }

    if (
      closestIndex >= 0 &&
      closestIndex < originalPath.length - 1 &&
      closestPointOnSegment
    ) {
      const remainingPath = [
        closestPointOnSegment,
        ...originalPath.slice(closestIndex + 1),
      ];

      const currentPath = this.driverPolyline.getPath().getArray();
      const pathChanged =
        remainingPath.length !== currentPath.length ||
        remainingPath.some((p, i) => {
          const cp = currentPath[i];
          return (
            !cp ||
            google.maps.geometry.spherical.computeDistanceBetween(p, cp) > 1
          );
        });

      if (pathChanged) {
        this.driverPolyline.setPath(remainingPath);
      }

      /* 🔥 ADDITION STARTS HERE (NO EXISTING CODE MODIFIED) */

      const remainingRoutePolyline = {
        points: remainingPath.map(p => ({
          lat: p.lat(),
          lng: p.lng(),
        })),
      };

      const result = this.etaService.getDistanceAndEta(remainingRoutePolyline);

      this.distance.set(result.distance); // meters
      this.eta.set(result.time); // seconds

      /* 🔥 ADDITION ENDS HERE */
    }
  }

  // utility to shorten address for the button hint
  private shortenAddress(addr?: string): string | null {
    if (!addr) return null;
    if (addr.length <= 40) return addr;
    return addr.slice(0, 37) + '...';
  }

  private getDropoffButtonLabel(
    target: { lat: number; lng: number } | null | undefined
  ): string {
    const baseLabel = this.translate.translate('gotothedropoff');
    if (!target) {
      return baseLabel;
    }

    const matchedStop = this.immediateLocationsDirections().find((item: any) =>
      this.isSameCoordinate(item?.data, target)
    );
    const dropoffIndex = Number(matchedStop?.index);

    return Number.isFinite(dropoffIndex)
      ? `${baseLabel} ${dropoffIndex + 1}`
      : baseLabel;
  }

  private isSameCoordinate(
    a: { lat: number; lng: number } | null | undefined,
    b: { lat: number; lng: number } | null | undefined,
    epsilon = 0.0001
  ): boolean {
    if (!a || !b) {
      return false;
    }

    return (
      Math.abs(Number(a.lat) - Number(b.lat)) < epsilon &&
      Math.abs(Number(a.lng) - Number(b.lng)) < epsilon
    );
  }

  private distanceBetween(
    a: google.maps.LatLngLiteral,
    b: google.maps.LatLngLiteral
  ): number {
    // Haversine in meters
    const R = 6371e3;
    const φ1 = (a.lat * Math.PI) / 180;
    const φ2 = (b.lat * Math.PI) / 180;
    const Δφ = ((b.lat - a.lat) * Math.PI) / 180;
    const Δλ = ((b.lng - a.lng) * Math.PI) / 180;
    const sinDφ = Math.sin(Δφ / 2);
    const sinDλ = Math.sin(Δλ / 2);
    const aa = sinDφ * sinDφ + Math.cos(φ1) * Math.cos(φ2) * sinDλ * sinDλ;
    const c = 2 * Math.atan2(Math.sqrt(aa), Math.sqrt(1 - aa));
    return R * c;
  }

  /**
   * Only call dataService.setShow when the boolean actually changes.
   */
  private setButtonShow(show: boolean): void {
    if (this.lastShow === show) return; // no change -> noop
    this.lastShow = show;
    try {
      this.dataService.setShow(show);
    } catch (e) {
      console.error('setButtonShow failed', e);
    }
  }

  /**
   * Safe setter for label — sets only when different.
   */
  private setButtonLabel(label: string | null): void {
    const l = label ?? '';
    if (this.lastLabel === l) return;
    this.lastLabel = l;
    try {
      this.dataService.setLabel(l);
    } catch (e) {
      console.error('setButtonLabel failed', e);
    }
  }

  private getCanonicalStopsForUI(): Array<{
    id: any;
    data: { lat: number; lng: number };
    is_completed?: boolean;
    index?: number;
  }> {
    const raw = this.immediateLocationsDirections?.() ?? [];
    const stops = (raw || []).map((s: any, idx: number) => ({
      id: s.id,
      data: {
        lat: Number(s.data?.lat ?? s.lat ?? 0),
        lng: Number(s.data?.lng ?? s.long ?? s.lng ?? 0),
      },
      index: typeof s.index !== 'undefined' ? s.index : idx,
    }));
    // fallback to enquiry.locations if empty
    if (!stops.length && Array.isArray(this.enquiry()?.locations)) {
      return (this.enquiry().locations || []).map((l: any, idx: number) => ({
        id: l.id,
        data: { lat: Number(l.lat ?? 0), lng: Number(l.long ?? l.lng ?? 0) },
        index: idx,
      }));
    }
    return stops;
  }

  transactionPay(): void {
    const enqId = this.enquiry()?.id;
    if (!enqId) return;
    this._EnquiryService
      .getTransactionEnquiry(enqId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: TransportPayment) => {
        this.transactionEnequiry.set(res);
        if (this.transactionEnequiry()?.is_payment_pending === false) {
          this.rideCompletedShowCashPaid();
        } else {
          this.rideCompleted();
        }
      });
  }
  /**
   * Safe setter for next stop address hint.
   */
  private setNextStopAddress(addr: string | null): void {
    const a = addr ?? '';
    if (this.lastNextAddr === a) return;
    this.lastNextAddr = a;
    this.dataService.setNextStopAddress(addr);
  }

  rideCompletedShowCashPaid() {
    this.closeExistingDialogsAndWidgets();
    this.ref = this.dialogService.open(RideCompletedModalComponent, {
      header: '',
      width: '26vw',
      height: '17vw',
      modal: true,
      closable: false,
      styleClass: 'ride_complet_modal',
      contentStyle: { overflow: 'auto' },
      data: this.enquiry(),
    });
  }

  rideCompleted() {
    this.closeExistingDialogsAndWidgets();
    this.ref = this.dialogService.open(RideCompletedComponent, {
      header: '',
      width: '26vw',
      height: '30vw',
      modal: true,
      closable: false,
      styleClass: 'payment',
      data: { id: this.enquiry().id },
    });
  }

  private closeExistingDialogsAndWidgets(): void {
    if (this.ref) {
      this.ref.close();
    }

    this._EnquiryService.setDriverSOcketDataAllEnquiry({
      enquiry: null,
      showList: false,
      all: true,
    });
    this._EnquiryService.setDriverSOcketData({
      enquiry: null,
      showList: false,
    });
    this._EnquiryService.setDriverSOcketDataImmedidate({
      enquiry: null,
      showList: false,
    });
  }

  private leavetrip(): void {
    const payload: joinTrip = {
      trip_id: Number(this.enquiry()?.trip_id ?? 0),
      enquiry_id: Number(this.enquiry()?.id ?? 0),
    };
    this._socket.leaveTripTracking(payload).subscribe(() => {});
  }

  ngOnDestroy(): void {
    this.discardReservedGoogleMapsTab();
    this.leavetrip();
    this.trackingSocketService.clearTrackingSocket();
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    this.markerAnimationTimeouts.forEach(t => clearTimeout(t));
    this.clearStopMarkers();

    if (this.driverPolyline) {
      this.driverPolyline.setMap(null);
      this.driverPolyline = null;
    }
    if (this.driverMarkerInstance) {
      this.driverMarkerInstance.setMap(null);
      this.driverMarkerInstance = null;
    }
  }
}
